import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  plantWithoutStatInspChartData: { data: { series: [] } },
  timedDefectStatusesChartData: { data: { series: [] } },
  untimedDefectStatusesChartData: { data: { series: [] } },
  safedStatusesChartData: { data: { series: [] } },
  statInspStatusesChartData: { data: { series: [] } },
  quoteMetric: {}
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
